import { makeStyles } from 'tss-react/mui';

export const useUserNoAccessStyles = makeStyles()(
  (theme) => ({
    root: {
      textAlign: 'center',
      color: '#333',
    },
    content: {
      display: 'grid',
      alignSelf: 'center',
      marginTop: '26vh',
      justifyContent: 'center',
      alignContent: 'center',
    },
    noAccess: {
      fontSize: '50px',
      fontStyle: 'normal',
      fontWeight: 700,
    },
    errorText: {
      width: '68%',
      fontSize: '20px',
      lineHeight: '30px',
      fontWeight: 300,
      margin: 'auto',
    },
    lockIcon: {
      fontSize: '4.1875rem',
    },
  })
);
